export enum CookieKeys {
  ACCESS_TOKEN_KEY = 'access_token',
  USER_ROLE_KEY = 'user_role'
}
